var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E85FC",
    d: "M9.76372359,-0.503643764 C10.0418784,-0.810568509 10.516179,-0.833891182 10.8231038,-0.555736411 C11.1021263,-0.302868439 11.1467669,0.112103576 10.9435956,0.416060319 L10.8751964,0.503643764 L4.86068641,7.14024376 C4.60353299,7.42399495 4.17984345,7.46468074 3.87557656,7.25166444 L3.78816513,7.18013785 L-0.516784872,3.08707785 C-0.816972539,2.80166545 -0.828950255,2.32694279 -0.543537851,2.02675513 C-0.284072029,1.75385725 0.131848544,1.71914941 0.430861558,1.92952881 L0.516784872,2.00000215 L4.264,5.564 L9.76372359,-0.503643764 Z",
    transform: "translate(1.563 1.339)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.1347f10ae52cbff4c7d9b8ab49f47d30.svg";
export { ForwardRef as ReactComponent };